import { computed } from 'vue';
import { $api } from './useApi';
import type { HeroData } from '@/models/hero';
import type { BenefitsData } from '@/models/benefit';
import type { ReferenceSectionApiResponse } from '@/models/reference';
import type { ServicesSectionContent } from '@/models/service';

export const useHomePage = async () => {
  const { data } = await useAsyncData(`home-data`, async (_nuxtApp, options) => {
    const [baseData, benefitsData, referencesData, servicesData] = await Promise.all([
      $api<HeroData>('/home/hero', { signal: options?.signal }),
      $api<BenefitsData>('/home/benefits-section', { signal: options?.signal }),
      $api<ReferenceSectionApiResponse>('/home/partner-section', { signal: options?.signal }),
      $api<ServicesSectionContent>('/home/use-case-section', { signal: options?.signal })
    ]);

    return { baseData, benefitsData, referencesData, servicesData };
  });

  const heroData = computed(() => data.value?.baseData);

  const referenceSectionData = computed(() =>
    data.value?.referencesData
      ? {
          heading: data.value.referencesData.heading,
          references: data.value.referencesData.partners,
          showPartnerSection: data.value.referencesData.showPartnerSection
        }
      : undefined
  );

  const benefitsSectionData = computed(() => data.value?.benefitsData);

  const servicesSectionContent = computed(() => data.value?.servicesData);

  return {
    heroData,
    benefitsSectionData,
    referenceSectionData,
    servicesSectionContent
  };
};
